import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Phone, ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')`,
            filter: 'brightness(0.3) saturate(0.7)'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-charcoal via-brand-charcoal/90 to-brand-charcoal" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-gold-500 tracking-[0.3em] uppercase text-sm mb-6">
          Begin Your Forever
        </p>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-warm-100 mb-6">
          Ready to Say "I Do"?
        </h2>
        <p className="text-warm-100/70 text-lg max-w-2xl mx-auto mb-12">
          Let's create a ceremony that honors your love story. 
          Schedule a consultation to discuss your vision and how we can bring it to life.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <Link
            to="/booking"
            className="btn-gold text-sm tracking-[0.2em] uppercase flex items-center gap-3"
            data-testid="cta-book-consultation-btn"
          >
            <Calendar className="w-5 h-5" />
            Book a Consultation
          </Link>
          <Link
            to="/contact"
            className="btn-gold-outline text-sm tracking-[0.2em] uppercase flex items-center gap-3"
            data-testid="cta-contact-btn"
          >
            <Phone className="w-5 h-5" />
            Get in Touch
          </Link>
        </div>

        {/* Quick info */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-8 text-warm-100/60 text-sm">
          <span className="flex items-center gap-2">
            <ArrowRight className="w-4 h-4 text-gold-500" />
            Free initial consultation
          </span>
          <span className="flex items-center gap-2">
            <ArrowRight className="w-4 h-4 text-gold-500" />
            Flexible scheduling
          </span>
          <span className="flex items-center gap-2">
            <ArrowRight className="w-4 h-4 text-gold-500" />
            Travel available
          </span>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
